import VerifySSNCode from './VerifySSNCode'

export default VerifySSNCode
